import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import '@polymer/polymer/lib/elements/dom-if.js';
import template from './ns-stripe-donation.html';
import {events} from '@nuskin/ns-util';

/**
 * Please put your description of ns-stripe-donation here
 *
 *
 * <br>
 *
 * <section>
 *  <h2>Content Guidelines</h2>
 *  <p>Here are some guidelines on how to properly use this element.</p>
 * </section>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-stripe-donation></ns-stripe-donation>
 *   </template>
 * </demo-snippet>
 */
export class NsStripeDonation extends PolymerElement {

    static get is() {
        return "ns-stripe-donation";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    constructor() {
        super()
    }

    ready() {
        super.ready();
        events.subscribe("nsStripeLoaded", () => {
            this.initStripeCheckout();
        });
        if (this.amount <= 0 || this.amount === undefined) {
            this.set("isOtherAmount", true);
        }
        if(!this.environment.includes("test")) {
            this.set("test", false);
        }
    }

    static get properties() {
        return {
            isOtherAmount: {
                type: Boolean, value: false
            },
            allowDecimal: {
                type: Boolean,
                value: false
            },
            test: {
                type: Boolean,
                value: true,
                notify: true
            },
            donateText: {
                type: String,
                value: "Donate"
            },
            explainerText: {
                type: String,
                value: "Whole Amounts Only"
            },
            otherAmountPlaceholder: String,
            amount: Number,
            key: String,
            image: {
                type: String,
                value: 'https://stripe.com/img/documentation/checkout/marketplace.png'
            },
            locale: String,
            name: String,
            description: String,
            zipcode: {
                type: Boolean,
                value: false
            },
            disabled: {
                type: Boolean,
                value: true
            },
            value: {
                type: Number,
                notify: true
            },
            environment: String,
            //Chargeurl should be the same whether it's on Prod or Test, but the key changes depending on environment.
            chargeurl: {
                type: String,
                value: "https://u6o3a52kt4.execute-api.us-east-2.amazonaws.com/Prod/charge"
            },
            completePath: String
        };
    }

    initStripeCheckout() {
        if(this.locale === undefined) {
            this.set("locale", "en");
        }
        this.handler = StripeCheckout.configure({
            key: this.environment, image: this.image, locale: this.locale, token: (token) => {
                this.postToken(token, () => {
                    if (this.completePath) {
                        window.location = this.completePath;
                    }
                });
            }
        });

        // Close Checkout on page navigation:
        window.addEventListener('popstate', function() {
            this.handler.close();
        });
    }

    openStripe(e) {
        e.preventDefault();
        if (this.handler) {
            this.handler.open({
                name: this.name, description: this.description, zipCode: this.zipcode, amount: this.amount
            });
        }
    }

    postToken(response, callback) {
        var postBody = {
            token: response.id, amount: this.amount, description: this.description, email: response.email, test: this.test
        };
        //TODO: Refactor jquery ajax post
        $.ajax({
            type: "POST",
            url: this.chargeurl,
            data: JSON.stringify(postBody),
            crossDomain: true,
            contentType: "application/json",
            success: response => {
                if (typeof callback === "function") {
                    callback();
                }
            },
            error: function(response) {
                console.error("Error in token post: ", response);
            }
        })
    }

    processOtherAmount(e) {
        var value = this.$.donationAmount.value;
        if(value > 0) {
            if(value.includes(".")) {
                value = value.replace(".", "");
            } else {
                value = value += "00";
            }
            console.log(value);
            this.set("amount", value);
            this.openStripe(e);
        }
    }

    checkVal() {
        this.$.donationAmount.value = parseFloat(this.$.donationAmount.value).toFixed(2);
    }

    formatInput(e) {
        if(e.which === 69 || e.which === 190 || e.which === 198) {
            e.preventDefault();
        }
    }

}

customElements.define(NsStripeDonation.is, NsStripeDonation);